export const AMERICAN_INDIAN = 'AIAN';
export const ASIAN_INDIAN = 'ASN';
export const AFRICAN_AMERICAN = 'AA';
export const NATIVE_HAWAIIAN_PACIFIC_ISLANDER = 'NHPI';
export const CAUCASIAN_WHITE = 'W';
export const OTHER = 'O';
export const NOT_AVAILABLE = 'NA';


// WEBPACK FOOTER //
// ./src/constants/ethnicityCodes.js